"use strict";
// reference enumeration for banking transactions
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankingTransactionTypes = void 0;
var BankingTransactionTypes;
(function (BankingTransactionTypes) {
    BankingTransactionTypes["banking_type_initial_buyin"] = "Initial Buy In";
    BankingTransactionTypes["banking_type_win_or_loss"] = "Win or Loss";
    BankingTransactionTypes["banking_type_chips_from_bank"] = "Chips from Bank";
    BankingTransactionTypes["banking_type_give_or_take_chips"] = "Give or Take Chips";
    BankingTransactionTypes["banking_type_transfer_from_player"] = "Transfer from Player";
    BankingTransactionTypes["banking_type_transfer_to_player"] = "Transfer to Player";
})(BankingTransactionTypes || (exports.BankingTransactionTypes = BankingTransactionTypes = {}));
//# sourceMappingURL=BankingTransactionTypes.js.map